import { trackHeartbeat, trackEvent } from "@/lib/api";

const KEY = "mopper_live_sid";

export function getSessionId() {
  let sid = sessionStorage.getItem(KEY);
  if (!sid) {
    sid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    sessionStorage.setItem(KEY, sid);
  }
  return sid;
}

export function sendHeartbeat(pathname) {
  const sid = getSessionId();
  trackHeartbeat(sid, pathname || window.location.pathname, document.referrer || undefined);
}

export function sendEvent(type, meta = {}) {
  const sid = getSessionId();
  trackEvent(sid, type, meta);
}
